// Angular imports
import { EventEmitter } from '@angular/core';
// Rxjs imports
import { Subject } from 'rxjs';
// Model imports
import { APBillParameterDto } from '../_models/accounts-payable/ap-bill/ap-bill-parameter-dto';
import { APPaymentParameterDto } from '../_models/accounts-payable/ap-payment/ap-payment-parameter-dto';
import { APAdjustmentParameterDto } from '../_models/accounts-payable/ap-adjustment/ap-adjustment-parameter-dto';
import { ARInvoiceDetailParameterDto } from '../_models/account-receivable/ar-invoice/ar-invoice-detail-parameter-dto';
import { ARAdjustmentParameterDto } from '../_models/account-receivable/ar-adjustment/ar-adjustment-parameter-dto';
import { ARPaymentParameterDto } from '../_models/account-receivable/ar-payment/ar-payment-parameter-dto';
import { CashReceiptParametersDto } from '../_models/cash-management/cash-receipts/cash-receipt-parameters-dto';
import { DepositParametersDto } from '../_models/cash-management/deposits/deposit-parameters-dto';
import { BatchParametersDto } from '../_models/cb-batches/batch-parameters-dto';
import { JournalEntryDetailParameterDto } from '../_models/general-ledger/journal-entry/journal-entry-detail-parameter-dto';
import { GLBatchSummaryParametersDto } from '../_models/general-ledger/gl-batch/gl-batch-summary-parameters-dto';
import * as i0 from "@angular/core";
export class DetailPopupsService {
    constructor() {
        this._subjectAPBillDetail = new Subject();
        this._subjectAPPaymentDetail = new Subject();
        this._subjectAPAdjustmentDetail = new Subject();
        this._subjectARInvoiceDetail = new Subject();
        this._subjectARPaymentDetail = new Subject();
        this._subjectARAdjustmentDetail = new Subject();
        this._subjectCashReceiptDetail = new Subject();
        this._subjectCashReceiptEditor = new Subject();
        this._subjectCashReceiptReverseEditor = new Subject();
        this._subjectDepositDetail = new Subject();
        this._subjectBatchDetail = new Subject();
        this._subjectJournalEntryDetail = new Subject();
        this._subjectJournalEntryEditor = new Subject();
        this._subjectWorkflowDetail = new Subject();
        this._subjectWorkflowViewer = new Subject();
        this._subjectGLBatchSummary = new Subject();
        this._subjectForceReload = new Subject();
        this.onDetailPopupClose = new EventEmitter();
    }
    getSubjectAPBillDetail() {
        return this._subjectAPBillDetail;
    }
    updateSubjectAPBillDetail(managementCompanyId, communityId, billId, vendorCode) {
        const param = new APBillParameterDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.billId = billId;
        param.clearCache = true;
        param.vendorCode = vendorCode;
        this._subjectAPBillDetail.next(param);
    }
    getSubjectAPPaymentDetail() {
        return this._subjectAPPaymentDetail;
    }
    updateSubjectAPPaymentDetail(managementCompanyId, communityId, paymentId, vendorCode) {
        const param = new APPaymentParameterDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.paymentId = paymentId;
        param.clearCache = false;
        param.vendorCode = vendorCode;
        this._subjectAPPaymentDetail.next(param);
    }
    getSubjectAPAdjustmentDetail() {
        return this._subjectAPAdjustmentDetail;
    }
    updateSubjectAPAdjustment(managementCompanyId, communityId, adjustmentId) {
        const param = new APAdjustmentParameterDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.id = adjustmentId;
        param.clearCache = true;
        this._subjectAPAdjustmentDetail.next(param);
    }
    getSubjectARInvoiceDetail() {
        return this._subjectARInvoiceDetail;
    }
    updateSubjectARInvoiceDetail(managementCompanyId, communityId, invoiceId) {
        const param = new ARInvoiceDetailParameterDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.invoiceId = invoiceId;
        param.clearCache = true;
        this._subjectARInvoiceDetail.next(param);
    }
    getSubjectARPaymentDetail() {
        return this._subjectARPaymentDetail;
    }
    updateSubjectARPaymentDetail(managementCompanyId, communityId, paymentId, vendorCode) {
        const param = new ARPaymentParameterDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.paymentId = paymentId;
        param.clearCache = false;
        param.vendorCode = vendorCode;
        this._subjectARPaymentDetail.next(param);
    }
    getSubjectARAdjustmentDetail() {
        return this._subjectARAdjustmentDetail;
    }
    updateSubjectARAdjustment(managementCompanyId, communityId, adjustmentId) {
        const param = new ARAdjustmentParameterDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.adjustmentId = adjustmentId;
        param.clearCache = true;
        this._subjectARAdjustmentDetail.next(param);
    }
    getSubjectCashReceiptDetail() {
        return this._subjectCashReceiptDetail;
    }
    updateSubjectCashReceiptDetail(managementCompanyId, communityId, receiptId) {
        const param = new CashReceiptParametersDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.id = receiptId;
        param.clearCache = true;
        this._subjectCashReceiptDetail.next(param);
    }
    getSubjectCashReceiptEditor() {
        return this._subjectCashReceiptEditor;
    }
    updateSubjectCashReceiptEditor(title, cashReceiptResult, cashReceiptParam) {
        const param = {
            title,
            cashReceiptResult,
            cashReceiptParam
        };
        this._subjectCashReceiptEditor.next(param);
    }
    getSubjectCashReceiptReverseEditor() {
        return this._subjectCashReceiptReverseEditor;
    }
    updateSubjectCashReceiptReverseEditor(cashReceiptResult, cashReceiptParam) {
        const param = {
            cashReceiptResult,
            cashReceiptParam
        };
        this._subjectCashReceiptReverseEditor.next(param);
    }
    getSubjectDepositDetail() {
        return this._subjectDepositDetail;
    }
    updateSubjectDepositDetail(managementCompanyId, communityId, depositId) {
        const param = new DepositParametersDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.cmDepositId = depositId;
        param.clearCache = true;
        this._subjectDepositDetail.next(param);
    }
    getSubjectJournalEntryDetail() {
        return this._subjectJournalEntryDetail;
    }
    updateSubjectJournalEntryDetail(managementCompanyId, communityId, journalEntryId) {
        const param = new JournalEntryDetailParameterDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.journalEntryId = journalEntryId;
        param.clearCache = true;
        this._subjectJournalEntryDetail.next(param);
    }
    getSubjectJournalEntryEditor() {
        return this._subjectJournalEntryEditor;
    }
    updateSubjectJournalEntryEditor(managementCompanyId, communityId, journalEntryId, isDuplicateAction = false) {
        const param = new JournalEntryDetailParameterDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.journalEntryId = journalEntryId;
        param.isDuplicateAction = isDuplicateAction;
        param.clearCache = true;
        this._subjectJournalEntryEditor.next(param);
    }
    getSubjectBatchDetail() {
        return this._subjectBatchDetail;
    }
    updateSubjectBatchDetail(managementCompanyId, communityId, batchId, batchType) {
        const param = new BatchParametersDto();
        param.managementCompanyID = managementCompanyId;
        param.communityID = communityId;
        param.batchID = batchId;
        param.type = batchType;
        param.clearCache = true;
        this._subjectBatchDetail.next(param);
    }
    getSubjectWorkflowDetail() {
        return this._subjectWorkflowDetail;
    }
    updateSubjectWorkflowDetail(managementCompanyId, communityId, workflowId, vendorId) {
        this._subjectWorkflowDetail.next({ managementCompanyId, communityId, workflowId, vendorId });
    }
    getSubjectWorkflowViewer() {
        return this._subjectWorkflowViewer;
    }
    updateSubjectWorkflowViewer(managementCompanyId, communityId, workflowId) {
        this._subjectWorkflowViewer.next({ managementCompanyId, communityId, workflowId });
    }
    getSubjectGLBatchSummary() {
        return this._subjectGLBatchSummary;
    }
    updateSubjectGLBatchSummary(managementCompanyId, communityId, batchId, accountingMethod, dimensions) {
        const param = new GLBatchSummaryParametersDto();
        param.managementCompanyId = managementCompanyId;
        param.communityId = communityId;
        param.batchId = batchId;
        param.accountingMethod = accountingMethod;
        param.dimensions = dimensions;
        this._subjectGLBatchSummary.next(param);
    }
    updateForceReload(value) {
        this._subjectForceReload.next(value);
    }
    onForceReload() {
        return this._subjectForceReload;
    }
    hasDetailsPopup(source, sourceType, batchId) {
        return (this.isAPBill(source, sourceType) ||
            this.isAPPayment(source, sourceType) ||
            this.isAPAdjustment(source, sourceType) ||
            this.isARInvoice(source, sourceType) ||
            this.isARPayment(source, sourceType) ||
            this.isARAdjustment(source, sourceType) ||
            this.isCashReceipt(source, sourceType) ||
            this.isDeposit(source, sourceType) ||
            this.isBatchDetails(sourceType, batchId) ||
            this.isJournalEntry(source, sourceType));
    }
    showDetailsPopup(source, sourceType, params) {
        if (this.isAPBill(source, sourceType)) {
            this.updateSubjectAPBillDetail(params.managementCompanyId, params.communityId, params.headerId, params.vendorCode);
        }
        else if (this.isAPPayment(source, sourceType)) {
            this.updateSubjectAPPaymentDetail(params.managementCompanyId, params.communityId, params.headerId, params.vendorCode);
        }
        else if (this.isAPAdjustment(source, sourceType)) {
            this.updateSubjectAPAdjustment(params.managementCompanyId, params.communityId, params.headerId);
        }
        else if (this.isARInvoice(source, sourceType)) {
            this.updateSubjectARInvoiceDetail(params.managementCompanyId, params.communityId, params.headerId);
        }
        else if (this.isARPayment(source, sourceType)) {
            this.updateSubjectARPaymentDetail(params.managementCompanyId, params.communityId, params.headerId, params.vendorCode);
        }
        else if (this.isARAdjustment(source, sourceType)) {
            this.updateSubjectARAdjustment(params.managementCompanyId, params.communityId, params.headerId);
        }
        else if (this.isCashReceipt(source, sourceType)) {
            this.updateSubjectCashReceiptDetail(params.managementCompanyId, params.communityId, params.headerId);
        }
        else if (this.isDeposit(source, sourceType)) {
            this.updateSubjectDepositDetail(params.managementCompanyId, params.communityId, params.headerId);
        }
        else if (this.isJournalEntry(source, sourceType)) {
            this.updateSubjectJournalEntryDetail(params.managementCompanyId, params.communityId, params.headerId);
        }
        else if (this.isBatchDetails(sourceType, params.batchId)) {
            this.updateSubjectBatchDetail(params.managementCompanyId, params.communityId, params.batchId, source);
        }
    }
    sourceTypeCode(sourceType) {
        return sourceType.toUpperCase().replace(/ /gi, '_');
    }
    isAPBill(source, sourceType) {
        return (['AP', 'AP_BILL'].indexOf(this.sourceTypeCode(source)) !== -1 &&
            ['B', 'HB', 'AP_BILL', 'HIST_AP_BILL', 'BILL'].indexOf(this.sourceTypeCode(sourceType)) !== -1);
    }
    isAPPayment(source, sourceType) {
        return (['AP', 'AP_PAYMENT', 'CASH_DISBURSEMENT'].indexOf(this.sourceTypeCode(source)) !== -1 &&
            ['P', 'HP', 'AP_PAYMENT', 'HIST_AP_PAYMENT', 'CASH_DISBURSEMENT', 'PAYMENT'].indexOf(this.sourceTypeCode(sourceType)) !== -1);
    }
    isAPAdjustment(source, sourceType) {
        return (['AP', 'AP_ADJUSTMENT'].indexOf(this.sourceTypeCode(source)) !== -1 &&
            ['A', 'HA', 'AP_ADJUSTMENT', 'HIST_AP_ADJUSTMENT', 'ADJUSTMENT'].indexOf(this.sourceTypeCode(sourceType)) !== -1);
    }
    isARInvoice(source, sourceType) {
        return (['AR', 'AR_INVOICE'].indexOf(this.sourceTypeCode(source)) !== -1 &&
            ['I', 'HI', 'AR_INVOICE', 'HIST_AR_INVOICE', 'INVOICE'].indexOf(this.sourceTypeCode(sourceType)) !== -1);
    }
    isARPayment(source, sourceType) {
        return (['AR', 'AR_PAYMENT'].indexOf(this.sourceTypeCode(source)) !== -1 &&
            ['P', 'HP', 'AR_PAYMENT', 'HIST_AR_PAYMENT', 'PAYMENT'].indexOf(this.sourceTypeCode(sourceType)) !== -1);
    }
    isARAdjustment(source, sourceType) {
        return (['AR', 'AR_ADJUSTMENT'].indexOf(this.sourceTypeCode(source)) !== -1 &&
            ['A', 'HA', 'AR_ADJUSTMENT', 'HIST_AR_ADJUSTMENT', 'ADJUSTMENT'].indexOf(this.sourceTypeCode(sourceType)) !== -1);
    }
    isCashReceipt(source, sourceType) {
        return source === 'CM' && ['CM_CASH_RECEIPT', 'CASH_RECEIPT'].indexOf(this.sourceTypeCode(sourceType)) !== -1;
    }
    isDeposit(source, sourceType) {
        return (['CM', 'DEPOSIT'].indexOf(this.sourceTypeCode(source)) !== -1 &&
            ['CM_DEPOSIT', 'DEPOSIT'].indexOf(this.sourceTypeCode(sourceType)) !== -1);
    }
    isJournalEntry(source, sourceType) {
        return source === 'GL' || sourceType === 'GL_JOURNAL' || sourceType === 'Journal Entry';
    }
    isBatchDetails(sourceType, batchId) {
        return this.sourceTypeCode(sourceType) === 'BATCH' || !!batchId;
    }
}
DetailPopupsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DetailPopupsService_Factory() { return new DetailPopupsService(); }, token: DetailPopupsService, providedIn: "root" });
